import '../themeDefaults';
import { ComposedTheme, createUseStyles } from '@glu/theming';
import { IBadgeProps } from './Badge';

type TBadgeStyleProps = Pick<IBadgeProps, 'backgroundColor'>;

export default createUseStyles<
  'root' | 'draggable' | 'small' | 'secondary',
  TBadgeStyleProps,
  ComposedTheme
>(
  ({
    badge: {
      backgroundColor: { primaryBackgroundColor },
      color: { primaryColor, secondaryColor },
    },
    spacing,
    typography,
  }) => {
    return {
      root: {
        ...typography.smallText,
        backgroundColor: ({ backgroundColor: background }) => background || primaryBackgroundColor,
        borderRadius: 4,
        color: primaryColor,
        display: 'inline-flex',
        padding: [spacing.unit / 2, spacing.unit, spacing.unit / 2, spacing.unit],
        alignItems: 'center',
        '& svg': {
          fill: primaryColor,
          width: 14,
        },
      },
      draggable: {
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing',
        },
      },
      small: {
        ...typography.xtraSmallText,
        '& svg': {
          width: 12,
        },
      },
      secondary: {
        color: secondaryColor,
        '& svg': {
          fill: secondaryColor,
        },
      },
    };
  }
);
